import React from 'react';
import { Box, Typography } from '@mui/material';
import HourCell from './HourCell';
import { HOURS } from './constants';
const DayColumn = React.memo(({
  day,
  dayIndex,
  schedule,
  isAllSelected,
  onToggleAllDay,
  onMouseDown,
  onMouseEnter,
  isLastDay
}) => <Box sx={{
  flex: 1,
  borderRight: isLastDay ? 'none' : '1px solid #fff'
}}>
    {/* Day Header with All Day Toggle */}
    <Box sx={{
    height: '60px',
    borderBottom: '1px solid #fff',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9'
  }}>
      <Typography sx={{
      fontSize: '13px',
      fontWeight: 500,
      color: '#212121',
      textAlign: 'center',
      pt: 1,
      pb: 0.5
    }}>
        {day}
      </Typography>
      <Box onClick={onToggleAllDay} sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      backgroundColor: isAllSelected ? '#7CB9E8' : '#f9f9f9',
      color: isAllSelected ? '#fff' : '#666',
      fontSize: '12px',
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: isAllSelected ? '#6BA9D8' : '#e9e9e9'
      }
    }}>
        All day
      </Box>
    </Box>

    {/* Hour Cells */}
    {HOURS.map(hour => <HourCell key={hour} day={day} hour={hour} isSelected={schedule[hour]} onMouseDown={onMouseDown} onMouseEnter={onMouseEnter} />)}
  </Box>);
DayColumn.displayName = 'DayColumn';
export default DayColumn;